/* global sciBclFlags */
export const calculateBonuses = ( purchaseValue, remainingBonos ) => {
	switch ( sciBclFlags.SCI_BCL_ORG ) {
		case 'VILLAVICIOSA':
			return calculateBonusesVillaviciosa( purchaseValue );
		case 'SIERO':
			return calculateBonusesSiero( purchaseValue, remainingBonos );
		case 'ACOSEVI_FEB_24':
			return calculateBonusesAcoseviFeb24( purchaseValue );
		case 'ACOSEVI_MAR_25':
			return calculateBonusesAcoseviMar25( purchaseValue );
		default:
			throw new Error( 'No se ha encontrado la organización' );
	}
};

const calculateBonusesVillaviciosa = ( purchaseValue ) => {
	const bonus = {
		type: 200,
		quantity: 0,
		maxDiscount: 0,
	};

	if ( purchaseValue >= 500 && purchaseValue < 1000 ) {
		bonus.quantity = 1;
		bonus.maxDiscount = 200;
	} else if ( purchaseValue >= 1000 && purchaseValue < 1500 ) {
		bonus.quantity = 2;
		bonus.maxDiscount = 400;
	} else if ( purchaseValue >= 1500 && purchaseValue < 2000 ) {
		bonus.quantity = 3;
		bonus.maxDiscount = 600;
	} else if ( purchaseValue >= 2000 && purchaseValue < 3000 ) {
		bonus.quantity = 4;
		bonus.maxDiscount = 800;
	} else if ( purchaseValue >= 3000 && purchaseValue < 7000 ) {
		bonus.type = 1000;
		bonus.quantity = 1;
		bonus.maxDiscount = 1000;
	} else if ( purchaseValue >= 7000 && purchaseValue < 12000 ) {
		bonus.type = 1000;
		bonus.quantity = 2;
		bonus.maxDiscount = 2000;
	} else if ( purchaseValue >= 12000 && purchaseValue < 16000 ) {
		bonus.type = 1000;
		bonus.quantity = 3;
		bonus.maxDiscount = 3000;
	} else if ( purchaseValue >= 16000 ) {
		bonus.type = 1000;
		bonus.quantity = 4;
		bonus.maxDiscount = 4000;
	}

	return bonus;
};

const calculateBonusesSiero = ( purchaseValue, remainingBonos ) => {
	const bonus = {
		type: 1000,
		quantity: 0,
		maxDiscount: 0,
	};

	// hasta 3 por compra (de 30 hasta 59,99 euros 1 bono, de 60 a 89,99 2 bonos y a partir de 90 3 bonos)
	if ( purchaseValue >= 3000 && purchaseValue < 6000 ) {
		bonus.quantity = 1;
		bonus.maxDiscount = 1000;
	} else if ( purchaseValue >= 6000 && purchaseValue < 9000 ) {
		bonus.quantity = 2;
		bonus.maxDiscount = 2000;
	} else if ( purchaseValue >= 9000 ) {
		bonus.quantity = 3;
		bonus.maxDiscount = 3000;
	}

	// Comprobamos que la cantidad de bonos no es superor a la cantidad de bonos que le quedan para canejar al comercio.
	if ( remainingBonos && remainingBonos < bonus.quantity ) {
		bonus.quantity = remainingBonos;
		bonus.maxDiscount = remainingBonos * 1000;
	}

	return bonus;
};

const calculateBonusesAcoseviFeb24 = ( purchaseValue ) => {
	const bonus = {
		type: 500,
		quantity: 0,
		maxDiscount: 0,
	};

	// Hasta dos por compra. 1 bono por cada 25€ de compra.
	if ( purchaseValue >= 2500 && purchaseValue < 5000 ) {
		bonus.quantity = 1;
		bonus.maxDiscount = 500;
	} else if ( purchaseValue >= 5000 ) {
		bonus.quantity = 2;
		bonus.maxDiscount = 1000;
	}

	return bonus;
};

const calculateBonusesAcoseviMar25 = ( purchaseValue ) => {
	const bonus = {
		type: 500,
		quantity: 0,
		maxDiscount: 0,
	};

	// Hasta tres por compra. 1 bono por cada 25€ de compra.
	if ( purchaseValue >= 2500 && purchaseValue < 5000 ) {
		bonus.quantity = 1;
		bonus.maxDiscount = 500;
	} else if ( purchaseValue >= 5000 && purchaseValue < 7500 ) {
		bonus.quantity = 2;
		bonus.maxDiscount = 1000;
	} else if ( purchaseValue >= 7500 ) {
		bonus.quantity = 3;
		bonus.maxDiscount = 1500;
	}

	return bonus;
};
